import { render } from "./createProduct.vue?vue&type=template&id=9cd87974&scoped=true"
import script from "./createProduct.vue?vue&type=script&lang=js"
export * from "./createProduct.vue?vue&type=script&lang=js"

import "./createProduct.vue?vue&type=style&index=0&id=9cd87974&lang=less"
import "./createProduct.vue?vue&type=style&index=1&id=9cd87974&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cd87974"]])

export default __exports__